// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3WCM3","dragIcon":"Choice_dragIcon__33KQX","left":"Choice_left__2rAqG","input":"Choice_input__uChMx"};